/**
 * 표시용 변환 유틸.
 *
 * 여기 있는 URL 검사 두 개는 **렌더 직전의 재확인**입니다. 서버는 https 절대 URL 만 저장하지만
 * (`domain.ValidateSiteEntryURL`) 스키마가 바뀌거나 DB 를 직접 수정한 행이 섞일 수 있습니다.
 * 갤러리는 운영자 입력을 모든 구성원에게 보여주는 화면이라 한 겹 더 검사합니다.
 */

/** hostOf 는 URL 문자열에서 호스트만 뽑습니다(파싱 실패는 빈 문자열 — 표시를 생략합니다). */
export function hostOf(raw: unknown): string {
  try {
    return new URL(String(raw)).host;
  } catch {
    return "";
  }
}

/** isHttpsURL 은 절대 https URL 인지 봅니다 — 아니면 링크로 만들지 않습니다. */
export function isHttpsURL(raw: unknown): boolean {
  try {
    return new URL(String(raw)).protocol === "https:";
  } catch {
    return false;
  }
}

/** formatDate 는 Unix milliseconds 를 한국 날짜로 씁니다(실패하면 원값 그대로). */
export function formatDate(ms: number): string {
  try {
    return new Date(ms).toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch {
    return String(ms);
  }
}

/**
 * initial 은 아바타에 넣을 첫 글자입니다.
 *
 * `Array.from` 으로 쪼개는 이유는 이모지·한글 조합 문자 때문입니다 — `name[0]` 은 서로게이트
 * 페어를 반 토막 내 깨진 글리프(`�`)를 보여줍니다.
 */
export const initial = (name: string): string =>
  name.trim() ? (Array.from(name.trim())[0] ?? "?").toUpperCase() : "?";
